/**
 * Display-side mirror of the backend's `_compact_catalyst_event_summary`
 * (api/bkg/indexer_v2/agent/response.py).
 *
 * The backend only compacts summaries as it writes them, so events indexed
 * before that landed still carry multi-paragraph text. Applying the same rule
 * at render time keeps old and new events looking consistent.
 */
export const SUMMARY_CHAR_LIMIT = 240;

export function compactSummary(
  value: unknown,
  limit: number = SUMMARY_CHAR_LIMIT,
): string {
  if (typeof value !== "string") return "";
  let text = value.replace(/\s+/g, " ").trim();
  if (!text) return "";

  const sentenceEnd = text.search(/[.!?](\s|$)/);
  if (sentenceEnd !== -1) {
    text = text.slice(0, sentenceEnd + 1).trim();
  }
  if (text.length <= limit) return text;

  const clipped = text
    .slice(0, limit)
    .replace(/\s+\S*$/, "")
    .trim();
  return (
    (clipped || text.slice(0, limit).trim()).replace(/[.,;:!?…]+$/, "") + "..."
  );
}
